import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=27a5d5fc&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a5d5fc')) {
      api.createRecord('27a5d5fc', component.options)
    } else {
      api.reload('27a5d5fc', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=27a5d5fc&", function () {
      api.rerender('27a5d5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Loading.vue"
export default component.exports